import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

import { VenueMonthDeclaration } from '../entities/project-venue-month-declaration';

type Params = {
  projectId: number;
};

type Result = {
  [monthKey: string]: VenueMonthDeclaration;
};

export const getMonthDeclarations = createAppAsyncThunk(
  'projectVenueMonthDeclaration/getMonthDeclarations',
  async (
    { projectId }: Params,
    { extra: { projectVenueMonthDeclarationGateway, snackbarGateway } },
  ): Promise<Result> => {
    try {
      const monthDeclarations =
        await projectVenueMonthDeclarationGateway.getMonthDeclarations(
          projectId,
        );
      return monthDeclarations;
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('GetVenueMonthDeclarations.Message.error'));
}
